import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import { message } from 'antd';

import App from './app';
import { initOpenReplay } from './libs/utils/openreplay';

import './index.less';
import { SingleInstanceLock } from './components/single-instance-lock/single-instance-lock';

initOpenReplay();

message.config({
	duration: 3,
	maxCount: 1,
});

ReactDOM.render(
	<React.StrictMode>
		<SingleInstanceLock>
			<Router>
				<App />
			</Router>
		</SingleInstanceLock>
	</React.StrictMode>,
	document.getElementById('root'),
);
